import { createSelector } from 'reselect';
import { getOrganizationState } from 'src/modules/organization/selectors/getOrganizationState';

export const getOrganizationSyncData = createSelector([
  getOrganizationState,
], (state) => state.sync);
